/**
 * Mixpanel event names for the post-conversion onboarding (hub, checklists,
 * welcome modals, page intros).
 *
 * Names MUST stay lowercase and match the tracking plan
 * (Desktop/Storydoc/ONBOARDING_ANALYTICS_PLAN.md) — the [Onboarding] boards
 * key off these strings. The tours keep their own legacy names
 * (PLATFORM_TOUR_EVENTS / EDITOR_TOUR_EVENTS) for continuity.
 */
export const ONBOARDING_EVENTS = {
  VIEW_EDITOR_WALKTHROUGH_MODAL: "view walkthrough modal",
  CLOSE_WALKTHROUGH_MODAL: "close walkthrough modal",
  VIEW_ONBOARDING_HUB: "view onboarding hub",
  CLICK_ONBOARDING_TASK: "click onboarding task",
  COMPLETE_ONBOARDING_TASK: "complete onboarding task",
  DISMISS_ONBOARDING_PROGRESS_CARD: "dismiss onboarding progress card",
  OPEN_GET_STARTED_CHECKLIST: "open get started checklist",
  COMPLETE_GET_STARTED_TASK: "complete get started task",
  VIEW_PAGE_INTRO: "view page intro",
  DISMISS_PAGE_INTRO: "dismiss page intro",
} as const;

/** Super property splitting users who see the onboarding from everyone else. */
export const ONBOARDING_GROUP_PROP = "onboarding group";

export type TOnboardingHubEntryPoint =
  | "sidebar card"
  | "dashboard card"
  | "dashboard task"
  | "credits pill";
